var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRestoreHeader = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.535 8.95c-.35-.11-.725.083-.837.434-.625 1.964-2.463 3.283-4.575 3.283-2.642 0-4.79-2.094-4.79-4.667s2.148-4.667 4.79-4.667c1.152 0 2.238.402 3.096 1.114l-1.444-.238c-.366-.067-.706.186-.766.548-.06.364.186.707.549.766l2.83.468c.037.006.075.009.11.009.08 0 .157-.014.229-.04.024-.01.044-.027.068-.04.044-.023.09-.043.128-.075.024-.019.04-.047.06-.07.032-.032.065-.064.088-.104.017-.028.024-.062.036-.094.016-.04.038-.076.046-.12l.502-2.666c.068-.362-.17-.712-.532-.779-.36-.065-.71.17-.778.531l-.182.961C11.054 2.544 9.632 2 8.123 2 4.747 2 2 4.691 2 8s2.747 6 6.123 6c2.694 0 5.044-1.693 5.846-4.212.111-.35-.083-.725-.434-.837z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRestoreHeader, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/restore_header.65df39fd.svg";
export { ForwardRef as ReactComponent };